import SparkMD5 from 'spark-md5';

export function calcFileMd5(file: File) {
  return new Promise<string>((resolve) => {
    const chunkSize = 5 * 1024 * 1024;
    const chunks = Math.ceil(file.size / chunkSize);

    const spark = new SparkMD5.ArrayBuffer();
    const reader = new FileReader();

    let current = 0;

    function loadNext() {
      const start = current * chunkSize;
      const end = Math.min(start + chunkSize, file.size);

      reader.readAsArrayBuffer(file.slice(start, end));
    }

    reader.onload = (e: any) => {
      spark.append(e.target.result);
      current++;

      if (current < chunks) {
        loadNext();
      } else {
        resolve(spark.end());
      }
    };

    loadNext();
  });
}